import _ from '@lodash';
import { Avatar, Paper, Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { MdMail, MdPhone, MdPhoneAndroid } from 'react-icons/md';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    divProfile: {
        //background: 'linear-gradient(to right, ' + theme.palette.primary.dark + ' 0%, ' + theme.palette.primary.main + ' 100%)',
        height: "auto",
        minHeight: 150,
    },
    textColor: {
        color: theme.palette.type === 'dark' ? '#CCC' : '#666',
    }
});

class Responsavel extends XAPPComponent {

    render() {
        const { data, classes, xappRouteParams, idagendamento = null } = this.props;
        return (
            <Paper className={clsx(classes.divProfile, "flex items-center justify-center w-full md:justify-start mt-8")}>
                <Avatar className="w-96 h-96 ml-12" src={data.foto ? data.foto : "assets/images/avatars/profile.png"} />
                <div className="flex w-full items-center">
                    <div className="flex flex-col w-full items-start">
                        <Typography className={clsx(classes.textColor, "mx-16")} color="textSecondary">{data.nome}</Typography>
                        <div className="flex w-full mx-8 mt-6">
                            {data.fone && data.fone.length > 0 &&
                                <a
                                    className="font-medium flex justify-center items-center h-32 w-32"
                                    href={"tel:" + data.fone}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <MdPhone className="text-green text-20" />
                                </a>
                            }
                            {data.celular && data.celular.length > 0 &&
                                <a
                                    className="font-medium flex justify-center items-center h-32 w-32"
                                    href={"tel:" + data.celular}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <MdPhoneAndroid className="text-green text-20" />
                                </a>
                            }
                            {data.whatsapp && data.whatsapp.length > 0 &&
                                <a
                                    className="font-medium flex justify-center items-center h-32 w-32"
                                    href={"https://wa.me/" + data.whatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FaWhatsapp className="text-green text-20" />
                                </a>
                            }
                            {data.email && data.email.length > 0 &&
                                <a
                                    className="font-medium flex justify-center items-center h-32 w-32"
                                    href={"mailto:" + data.email}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <MdMail className="text-yellow-dark text-20" />
                                </a>
                            }
                        </div>
                        <Typography className={clsx(classes.textColor, "mx-16")} color="textSecondary">{"Registro conselho: " + data.registroconselho + "/" + data.registroconselhouf}</Typography>
                        <Typography className={clsx(classes.textColor, "mx-16")} color="textSecondary">{"Registro especialista: " + data.registroespecialista + "/" + data.registroespecialistauf}</Typography>
                        <Typography className={clsx(classes.textColor, "mx-16")} color="textSecondary">{"Observações: " + (!_.isUndefined(data.observacao) && !_.isNull(data.observacao) ? data.observacao : "")}</Typography>
                    </div>
                </div>
            </Paper>
        )
    }
}

export default withStyles(styles, { withTheme: true })(Responsavel);